// extracted by mini-css-extract-plugin
export default {"user-dropdown":"event-details-comments-composer_component_user-dropdown__Lhv4A"};